﻿import { FC, HTMLAttributes } from 'react';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'neutral' | 'teal';
}

export const Badge: FC<BadgeProps> = ({ children, variant = 'primary', className = '', ...props }) => {
  return (
    <span className={`cs-badge cs-badge-${variant} ${className}`.trim()} {...props}>
      {children}
    </span>
  );
};

